module.exports = __webpack_public_path__ + "img/dlsjjkxt3.0de9d7e4.jpg";